module.exports = __webpack_public_path__ + "img/empty-md-announcement.png?dd26b1a1";